import React, { Component } from "react";
import { Button, Container, Table, Row, Col } from 'reactstrap';
import { Navigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import Typography from "@mui/material/Typography";

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { Snackbar } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';

//import { DataGrid, GridToolbar } from '@mui/x-data-grid';



import AuthService from "../services/LoginService";
import EventBus from "../common/EventBus";

import { AddFormation } from "./AddFormation";
import FormationService from "../services/FormationService";


class FormationList extends Component {

    emptyFormation = {
        name: '',
        duration: '',
        prices: [
            {
                price: '',
                payMode: '',
            }
        ]
    };




    constructor(props) {
        super(props);
        this.state = {
            formations: [],
            redirect: null,
            addFormationShow: false,
            currentFormation: this.emptyFormation,
            snackbaropen: false,
            page: 1,
            count: 0,
            pageSize: 4,
            formationNameFilter: '',
        };

        this.pageSizes = [3, 4, 6, 9, 15, 25, 50];

        // this.remove = this.remove.bind(this);
        this.retrieveFormations = this.retrieveFormations.bind(this);
        // this.handlePageChange = this.handlePageChange.bind(this);
        this.remove = this.remove.bind(this);
        this.editFormation = this.editFormation.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    }


    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveFormations();
        }
    }


    retrieveFormations() {
        const { formationNameFilter, page, pageSize } = this.state;
        const params = this.getRequestParams(formationNameFilter, page, pageSize);
        FormationService.getAll(params)
            .then((response) => {
                const { formations, totalPages } = response.data;

                this.setState({
                    formations: formations,
                    count: totalPages,
                });
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }

    getRequestParams(formationNameFilter, page, pageSize) {
        let params = {};

        if (formationNameFilter) {
            params["formationName"] = formationNameFilter;
        }
        if (page) {
            params["page"] = page - 1;
        }

        if (pageSize) {
            params["size"] = pageSize;
        }

        return params;
    }

    handlePageSizeChange(event) {
        this.setState(
            {
                pageSize: event.target.value,
                page: 1
            },
            () => {
                this.retrieveFormations();
            }
        );
    }

    handlePageChange(event, value) {
        this.setState(
            {
                page: value,
            },
            () => {
                this.retrieveFormations();
            }
        );
    }

    async getFicheDocument(id, name) {
        FormationService.getFicheDocument(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', name); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }


    async getConvocationDocument(name) {
        FormationService.getConvocationDocument(name)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', name); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }


    editFormation(formation) {
        // studentId.preventDefault();
        //console.log('STUDENT List contactID = ' + contract.id);
        this.setState({ currentFormation: formation });
        this.setState({ addFormationShow: true });
    }

    remove(id) {
        FormationService.delete(id)
            .then((response) => {
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                this.retrieveFormations();
            })
            .catch((err) => {
                console.log(err);
                const { message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
            });
    }

    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    render() {

       

        

        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }

        const {
            formations,
            page,
            count,
            pageSize,
            isLoading,
        } = this.state;

        let addFormationClose = () => this.setState({ addFormationShow: false, currentFormation: this.emptyFormation });
        const reload = () => window.location.reload();

        if (isLoading) {
            return <p>Loading...</p>;
        }
        //const [value, setValue] = React.useState<Dayjs | null>(null);
        const formationList = formations.map(formation => {
            const startAmTime = dayjs('2023-01-01T' + formation.startAmTime);
            const startPmTime = dayjs('2023-01-01T' + formation.startPmTime);
            const endPmTime = dayjs('2023-01-01T' + formation.endPmTime);
            const endAmTime = dayjs('2023-01-01T' + formation.endAmTime);

            return <tr key={formation.id}>
                <td >{formation.name}</td>
                <td>
                    {formation.prices.map((elt, idx) => (
                        <div key={idx}>{elt.payMode} : {elt.price}&euro;</div>
                    ))}
                </td>
                <td>{formation.duration}</td>
                <td>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            disabled
                            ampm={false}
                            label="heure début"
                            value={startAmTime}
                            onChange={() => { ; }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            disabled
                            ampm={false}
                            label="heure fin "
                            value={endAmTime}
                            onChange={() => { ; }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                </td>
                <td>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            disabled
                            ampm={false}
                            label="heure début"
                            value={startPmTime}
                            onChange={() => { ; }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            disabled
                            ampm={false}
                            label="heure fin"
                            value={endPmTime}
                            onChange={() => { ; }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                </td>
                <td>
                    <Button variant="secondary" size="sm" onClick={() => this.getFicheDocument(formation.ficheId, formation.ficheName)} >{formation.ficheName}</Button>
                </td>

                <td>
                    <Button onClick={() => this.getConvocationDocument(formation.convocationModel)} style={{ display: "block", textAlign: "left" }}>
                        <Typography variant="caption" display="block" >
                            {formation.convocationModel}
                        </Typography>
                    </Button>
                </td>

                <td>
                    <IconButton aria-label="edit" color="primary" onClick={() => { this.editFormation(formation) }} >
                        <ModeEditIcon />
                    </IconButton>
                    <IconButton aria-label="delete" color="primary" onClick={() => this.remove(formation.id)}>
                        <DeleteIcon />
                    </IconButton>


                </td>
            </tr>
        });


   /*     const formationData = formations.map(formation => {
           // const startAmTime = dayjs('2023-01-01T' + formation.startAmTime);
           // const startPmTime = dayjs('2023-01-01T' + formation.startPmTime);
           // const endPmTime = dayjs('2023-01-01T' + formation.endPmTime);
           // const endAmTime = dayjs('2023-01-01T' + formation.endAmTime);

            return {id : formation.id, name: formation.name,  duration : formation.duration, ficheName : formation.ficheName }
        });
*/

        return (
            <div>
                <Container fluid>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={this.state.snackbaropen}
                        autoHideDuration={3000}
                        onClose={this.snackbarClose}
                        message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                        action={[
                            <IconButton
                                key="close"
                                aria-label='Close'
                                color='inherit'
                                onClick={this.snackbarClose}
                            >X</IconButton>
                        ]}
                    ></Snackbar>
                    <br />
                    <Row>
                        <Col xs={10} md={10}><h3>Formations</h3></Col>
                        <Col xs={2} md={2}>
                            <Button onClick={() => { this.editFormation(this.state.currentFormation) }}>Ajout Formation</Button>
                        </Col>
                    </Row>

                </Container>
                <Container fluid>

                    <br />

                    <Table striped hover size="sm">
                        <thead >
                            <tr >
                                <th width="25%">Nom</th>
                                <th width="20%">Prix</th>
                                <th width="5%">Durée</th>
                                <th width="10%">Horaire matin</th>
                                <th width="10%">Horaire aprèsm</th>
                                <th width="10%">Fiche</th>
                                <th width="10%">Convocation</th>
                                <th width="15%">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formationList}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>

                                <td colSpan={5} >
                                    <Pagination
                                        className="mx-12"
                                        count={count}
                                        page={page}
                                        siblingCount={1}
                                        boundaryCount={1}
                                        variant="outlined"
                                        shape="rounded"
                                        onChange={this.handlePageChange}
                                    />

                                </td>
                                <td colSpan={2}>
                                    {"Items per Page: "}
                                    <select onChange={this.handlePageSizeChange} value={pageSize}>
                                        {this.pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        </tfoot>

                    </Table>

                    <AddFormation show={this.state.addFormationShow} onHide={addFormationClose} onExit={reload} currentformation={this.state.currentFormation} ></AddFormation>
                </Container>

            </div>



        );
    }

/*
                <div style={{ height: 250, width: '60%' }}>
                    <DataGrid 
                        columns={[
                            { field: 'name', hideable: false },
                            { field: 'duration' },
                            { field: 'ficheName' },
                        ]}
                        rows={formationData}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                    />
                </div>
*/

}
export default FormationList;